






































import Vue from 'vue';
import BodyOrgans from '@/components/BodyOrgans.vue';

export default Vue.extend<any, any, any, any>({
	components: { BodyOrgans },
	props: {
		table: {
			type: Boolean,
			default: false,
		},
		dissected: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		isDragging: false,
		draggedOrgan: undefined,

		// Dropped organs. True means the organ has been dropped.
		organs: {
			lungs: false,
			heart: false,
			liver: false,
			kidneys: false,
			stomach: false,
			'intestine-lg': false,
			'intestine-sm': false,
		},
	}),
	computed: {
		isFinished() {
			const countDropps = Object.values(this.organs).filter(isDropped => !isDropped).length;
			return countDropps === 0;
		},
	},
	methods: {
		onTouchMove(event: TouchEvent) {
			if (!this.draggedOrgan) {
				return;
			}

			const { clientWidth, clientHeight } = this.$refs[this.draggedOrgan];
			this.$refs[this.draggedOrgan].style.display = 'inline';
			this.$refs[this.draggedOrgan].style.top = `${event.touches[0].pageY - clientHeight / 2}px`;
			this.$refs[this.draggedOrgan].style.left = `${event.touches[0].pageX - clientWidth / 2}px`;

			//this.dragHandler(this.draggedOrgan);
		},

		onTouchEnd(event: TouchEvent) {

			const { pageX, pageY } = event.changedTouches[0];
			document.elementsFromPoint(pageX, pageY).forEach((element: Element) => {
				if (element.classList.contains('table__area')) {
					this.dropHandler();
				}
			});

			if (this.draggedOrgan) {
				this.$refs[this.draggedOrgan].style.display = 'none';
				this.draggedOrgan = undefined;
			}
		},

		_dragginOrgan(organ: string): boolean {
			return Object.keys(this.organs).includes(organ);
		},

		// BodyOrgans
		// Invoked when the drag is initialized
		dragHandler(organ: string) {
			if (!this._dragginOrgan(organ)) {
				return;
			}

			this.draggedOrgan = organ;
			this.isDragging = true; // Enable some layers.
			this.$emit('dragging', this.isDragging);
		},

		// BodyOrgans
		// Invoked when the drag is terminated (escape or releasing it somewhere else)
		dragendHandler(organ: string) {
			if (!this._dragginOrgan(organ)) {
				return;
			}

			this.draggedOrgan = organ;
			this.isDragging = false; // Disable some layers.
			this.$emit('dragging', this.isDragging);
			this.$emit('finished', this.isFinished);
		},

		// .step4__table
		// Invoke when the drag is released
		dropHandler(event: DragEvent) {
			if (!this._dragginOrgan(this.draggedOrgan)) {
				event.preventDefault();
				return;
			}

			this.organs[this.draggedOrgan] = true;
			this.isDragging = false; // Disable some layers.
			this.$emit('dragging', this.isDragging);
			this.$emit('finished', this.isFinished);
		},

		// .step4__table
		// Invoke when the organ is dragged over the table
		dragoverHandler(event: DragEvent) {
			this.isDragging = true; // Enable some layers.
			this.$emit('dragging', this.isDragging);
			event.preventDefault(); // Allow drag-drop
		},
	},
});
